import _ from "lodash-es";

export type PaginationState = {
  pages: (number | "spacer")[];
  currentPage: number;
  numPages: number;
};

export function MakePaginationState(
  numItems: number,
  pageSize: number,
  currentPage: number = 1
): PaginationState {
  const numPages = Math.ceil(numItems / pageSize);

  const pagesVisibleToEachSide = 1;
  const pages = _.range(1, numPages + 1)
    .filter(
      (page) =>
        page == 1 ||
        page == numPages ||
        Math.abs(page - currentPage) <= pagesVisibleToEachSide + 1
    )
    .map((page) =>
      page == 1 ||
      page == numPages ||
      Math.abs(page - currentPage) <= pagesVisibleToEachSide
        ? page
        : "spacer"
    );

  return {
    currentPage: currentPage,
    numPages: Math.ceil(numItems / pageSize),
    pages: numPages <= 1 ? [] : pages,
  };
}
